<template>
  <div v-if="show" class="preview-modal-backdrop" @click="close">
    <div class="preview-modal" @click.stop>
      <div class="preview-modal-header">
        <div class="file-info">
          <feather-icon :icon="getIconForFile(file)" size="18" class="file-icon" />
          <span class="file-name">{{ file.name }}</span>
        </div>
        <div class="preview-actions">
          <button class="action-button" @click="download" title="Download">
            <feather-icon icon="DownloadIcon" size="16" />
          </button>
          <button class="action-button" @click="close" title="Fechar">
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>
      </div>
      <div class="preview-modal-body">
        <file-preview
          :file="file"
          :preview-url="previewUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FilePreview from './FilePreview.vue';

export default {
  name: 'FilePreviewModal',
  components: {
    FilePreview
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    file: {
      type: Object,
      required: true
    },
    previewUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    download() {
      this.$emit('download');
    },
    getIconForFile(file) {
      const extension = file.extension || file.name.split('.').pop().toLowerCase();

      switch (extension) {
        case 'pdf':
          return 'FileTextIcon';
        case 'txt':
          return 'FileTextIcon';
        case 'doc':
        case 'docx':
          return 'FileTextIcon';
        case 'xls':
        case 'xlsx':
        case 'csv':
          return 'FileTextIcon';
        case 'ppt':
        case 'pptx':
          return 'FileTextIcon';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'svg':
        case 'webp':
          return 'ImageIcon';
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'flac':
          return 'MusicIcon';
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
        case 'webm':
          return 'VideoIcon';
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
        case 'gz':
          return 'PackageIcon';
        case 'html':
        case 'css':
        case 'js':
        case 'ts':
          return 'CodeIcon';
        case 'xml':
        case 'json':
          return 'FileIcon';
        default:
          return 'FileIcon';
      }
    }
  }
}
</script>

<style scoped>
.preview-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
}

.preview-modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.preview-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.file-icon {
  color: var(--primary);
}

.file-name {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
  max-width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-actions {
  display: flex;
  gap: 0.5rem;
}

.action-button {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}

.action-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--primary);
}

.preview-modal-body {
  flex: 1;
  overflow: auto;
  padding: 1.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .preview-modal {
    width: 95%;
    max-height: 95vh;
  }

  .preview-modal-header {
    padding: 0.75rem 1rem;
  }

  .file-name {
    max-width: 200px;
  }

  .preview-modal-body {
    padding: 1rem;
  }
}
</style>
